import mwcMarketsCore from 'mwc-markets-core';
import Options from './src/options.vue';

const { createCustomElement } = mwcMarketsCore;
createCustomElement(Options);

export default Options;
